// Aquí está el slice de confirmación de cambio de contraseña por olvido
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  fpconfirming: false,
  fpconfirmed: false,
  fpsendCode: false,
  fperror: null,
};

const forgotPasswordSlice = createSlice({
  name: "forgotpassword",
  initialState,
  reducers: {
    fpStartConfirmation: (state) => {
      state.fpconfirming = true;
      state.fperror = null;
    },
    fpConfirmSuccess: (state) => {
      state.fpconfirming = false;
      state.fpconfirmed = true;
    },
    fpConfirmFailure: (state, action) => {
      state.fpconfirming = false;
      state.fperror = action.payload;
    },
    fpResendCodeSuccess: (state) => {
      state.fpsendCode = true;
    },
    fpResendCodeFailure: (state, action) => {
      state.fpsendCode = false;
      state.fperror = action.payload;
    },
    fpResetConfirmation: (state) => {
      state.fpconfirming = false;
      state.fpconfirmed = false;
      state.fperror = null;
      state.fpsendCode = false;
    },
  },
});

export const {
  fpStartConfirmation,
  fpConfirmSuccess,
  fpConfirmFailure,
  fpResendCodeSuccess,
  fpResendCodeFailure,
  fpResetConfirmation,
} = forgotPasswordSlice.actions;

export default forgotPasswordSlice.reducer;
